/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpResponse, HttpContext, HttpParams } from '@angular/common/http';
import { DataBaseService } from '../data-base-service';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ExportingDataModulesDto } from '../models/exporting-data-modules-dto';
import { ExportingEntitiesDto } from '../models/exporting-entities-dto';
import { ImportEntitiesDto } from '../models/import-entities-dto';
import { ImportResultDto } from '../models/import-result-dto';

@Injectable({ providedIn: 'root' })
export class ImportExportControllerService extends DataBaseService {

  /**
   * Path part for operation importExportControllerExportDataEntities
   */
  static readonly ImportExportControllerExportDataEntitiesPath = '/v1/export/entity';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportDataEntities()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  exportDataEntities$Response(params?: {
    extraParams?: HttpParams,
    context?: HttpContext
    body?: ExportingEntitiesDto
  }): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, ImportExportControllerService.ImportExportControllerExportDataEntitiesPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `exportDataEntities$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  exportDataEntities(params?: {
    extraParams?: HttpParams,
    context?: HttpContext
    body?: ExportingEntitiesDto
  }): Observable<Blob> {

    return this.exportDataEntities$Response(params).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * Path part for operation importExportControllerExportDataModel
   */
  static readonly ImportExportControllerExportDataModelPath = '/v1/export/module';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportDataModel()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  exportDataModel$Response(params?: {
    extraParams?: HttpParams,
    context?: HttpContext
    body?: ExportingDataModulesDto
  }): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, ImportExportControllerService.ImportExportControllerExportDataModelPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `exportDataModel$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  exportDataModel(params?: {
    extraParams?: HttpParams,
    context?: HttpContext
    body?: ExportingDataModulesDto
  }): Observable<Blob> {

    return this.exportDataModel$Response(params).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * Path part for operation importExportControllerConfirmFileImport
   */
  static readonly ImportExportControllerConfirmFileImportPath = '/v1/import/{fileId}/confirm';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `confirmFileImport()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  confirmFileImport$Response(params: {
    fileId: string;
    extraParams?: HttpParams,
    context?: HttpContext
    body?: ImportEntitiesDto
  }): Observable<StrictHttpResponse<ImportResultDto>> {

    const rb = new RequestBuilder(this.rootUrl, ImportExportControllerService.ImportExportControllerConfirmFileImportPath, 'post');
    if (params) {
      rb.path('fileId', params.fileId, {});
      rb.body(params.body, 'application/json');
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ImportResultDto>;
      })
    );
  }
  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `confirmFileImport$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  confirmFileImport(params: {
    fileId: string;
    extraParams?: HttpParams,
    context?: HttpContext
    body?: ImportEntitiesDto
  }): Observable<ImportResultDto> {

    return this.confirmFileImport$Response(params).pipe(
      map((r: StrictHttpResponse<ImportResultDto>) => r.body as ImportResultDto)
    );
  }

  /**
   * Path part for operation importExportControllerValidateFileToImport
   */
  static readonly ImportExportControllerValidateFileToImportPath = '/v1/import/{fileId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `validateFileToImport()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  validateFileToImport$Response(params: {
    fileId: string;
    extraParams?: HttpParams,
    context?: HttpContext
    body?: ImportEntitiesDto
  }): Observable<StrictHttpResponse<ImportResultDto>> {

    const rb = new RequestBuilder(this.rootUrl, ImportExportControllerService.ImportExportControllerValidateFileToImportPath, 'post');
    if (params) {
      rb.path('fileId', params.fileId, {});
      rb.body(params.body, 'application/json');
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ImportResultDto>;
      })
    );
  }
  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `validateFileToImport$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  validateFileToImport(params: {
    fileId: string;
    extraParams?: HttpParams,
    context?: HttpContext
    body?: ImportEntitiesDto
  }): Observable<ImportResultDto> {

    return this.validateFileToImport$Response(params).pipe(
      map((r: StrictHttpResponse<ImportResultDto>) => r.body as ImportResultDto)
    );
  }

}
